var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEye = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ver_1_",
    "data-name": "ver (1)",
    width: 24.783,
    height: 15.796,
    viewBox: "0 0 24.783 15.796",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M24.625,100.251c-.221-.3-5.5-7.416-12.234-7.416S.378,99.948.157,100.25a.818.818,0,0,0,0,.964c.221.3,5.5,7.416,12.234,7.416s12.013-7.113,12.234-7.416A.817.817,0,0,0,24.625,100.251ZM12.391,107c-4.963,0-9.261-4.721-10.534-6.264,1.271-1.545,5.56-6.263,10.534-6.263s9.261,4.72,10.534,6.264C21.654,102.278,17.365,107,12.391,107Z",
    transform: "translate(0 -92.835)",
    fill: "currentColor"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727",
    transform: "translate(7.489 2.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M159.624,154.725a4.9,4.9,0,1,0,4.9,4.9A4.908,4.908,0,0,0,159.624,154.725Zm0,8.17a3.268,3.268,0,1,1,3.268-3.268A3.272,3.272,0,0,1,159.624,162.9Z",
    transform: "translate(-154.722 -154.725)",
    fill: "currentColor"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye.1dea02bd.svg";
export { ForwardRef as ReactComponent };